import {PIXI} from '@colonist/pixi'
import {TextView} from './TextView'
import {GameFont} from '../GameFont'
import {TextButtonView} from './TextButtonView'
import {GameColor} from '../GameColor'

export class GameEndTabButtonView extends TextButtonView {
    private underline: PIXI.Graphics
    private readonly hoverBackgroundAlpha = 0.6
    private readonly defaultBackgroundAlpha = 0

    constructor(x: number, y: number, w: number, h: number, container: PIXI.Container) {
        super(x, y, w, h, container)
        this.viewContainer.makeRoundedBgInvisible()
        this.viewContainer.drawBg()
        this.viewContainer.bg.alpha = this.defaultBackgroundAlpha
        this.textView = new TextView({key: 'strings:colonistCommon.utils.emptyString'}, 0, 0, this.width, this.height, this.viewContainer, GameFont.Size.Normal, GameColor.getColor(GameColor.Color.Gray3))
        this.initializeUnderline()
    }

    highlight() {
        this.underline.visible = true
        this.textView.makeBold()
    }

    removeHighlight() {
        this.underline.visible = false
        this.textView.removeBold()
    }

    protected setHover() {
        this.interactive = true
        this.on('pointerover', (event) => {
            this.activateHoverEffect()
            this.hoverOn(event)
        })
        this.on('pointerout', (event) => {
            this.disactivateHoverEffect()
            this.hoverOut(event)
        })
    }

    private initializeUnderline() {
        const underlineAttributes = {
            y: this.height * 0.95,
            height: this.height * 0.09,
            alpha: 1,
            color: GameColor.Color.PrimaryBlue5,
        }

        this.underline = this.drawLine(0, underlineAttributes.y, this.width, underlineAttributes.y, underlineAttributes.height, underlineAttributes.alpha, underlineAttributes.color)
    }

    protected activateHoverEffect() {
        this.viewContainer.bg.alpha = this.hoverBackgroundAlpha
    }

    protected disactivateHoverEffect() {
        this.viewContainer.bg.alpha = this.defaultBackgroundAlpha
    }

    private drawLine(x1: number, y1: number, x2: number, y2: number, lineWidth: number = 10, alpha: number = 1, color: number = GameColor.getColorHexValue(GameColor.Color.GrayScale0)) {
        const line = new PIXI.Graphics()
        line.lineStyle(lineWidth, GameColor.getColorHexValue(color), alpha)
        line.moveTo(x1, y1)
        line.lineTo(x2, y2)
        this.addChild(line)
        return line
    }
}
